<template>
  <div v-show="workflowShow" class="workflow" @touchmove.stop="noTouch">
    <div class="workflow-mask" :class="{'show':showAnimate}" @click="closeToast"></div>
    <div class="workflow-container" :class="{'show':showAnimate}">
      <div class="close-btn" @click="closeToast">
        <img src="https://wecos.etczs.net/assets/images/toast-close.png" />
      </div>
      <div class="workflow-title">
        <div class="t">详细步骤</div>
      </div>
      <div class="apply-step-container">
        <div class="dashe-line"></div>
        <div class="apply-step-item no-wrap">
          <img class="item-img" src="https://wecos.etczs.net/assets/images/index-step-detail-1-1114.png" />
          <div class="item-label">
            <div class="t">填写资料</div>
            <div class="label-tag">每辆车仅允许办理1个ETC</div>
          </div>
          <div class="item-value">填写车牌及ETC设备收件地址。支持蓝牌或绿牌且9座及以下小客车办理</div>
        </div>
        <div class="apply-step-item no-wrap">
          <img class="item-img" src="https://wecos.etczs.net/assets/images/index-step-detail-2-0113.png" />
          <div class="item-label">开通ETC权益卡</div>
          <div class="item-value ">开通ETC权益卡，可得ETC和优惠礼包</div>
        </div>
        <div class="apply-step-item no-wrap">
          <img class="item-img" src="https://wecos.etczs.net/assets/images/index-step-detail-3-0113.png" />
          <div class="item-label">
            <div class="t">确认办理信息</div>
          </div>
          <div class="item-value">确认ETC办理信息并提交，等待发货</div>
        </div>
        <div class="apply-step-item no-wrap">
          <img class="item-img" src="https://wecos.etczs.net/assets/images/index-step-detail-4-1114.png" />
          <div class="item-label">收货并安装激活</div>
          <div class="item-value">收到设备后按指引完成安装激活，激活前需上传车主身份证和车辆行驶证</div>
        </div>
      </div>
      <div v-if="isRichMan" class="long-phone-btn"></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    noTouch(e) {
      e.preventDefault && e.preventDefault()
      return false
    },
    // 关闭弹窗
    closeToast(isClose = true) {
      this.$emit('close')
    },
    // 打开/关闭弹窗
    showWorkflow() {
      if (!this.show) {
        this.showAnimate = false
        setTimeout(() => {
          this.workflowShow = false
        }, 300)
      } else {
        /*  this.canSelectVehicleBelong = ~VEHICLE_BELONG_CARD_LIST.indexOf(
          this.currentCard.id
        ) */
        this.workflowShow = true
        setTimeout(() => {
          this.showAnimate = true
        }, 10)
      }
    }
  },
  watch: {
    show() {
      console.log(this.show)
      this.showWorkflow()
    }
  },
  props: {
    show: Boolean
  },
  data: () => ({
    workflowShow: false,
    showAnimate: false,
    canSelectVehicleBelong: false
  })
}
</script>

<style lang="scss" scoped>
.workflow {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 12;
  top: 0;
  left: 0;
  overflow: hidden;
  .workflow-mask {
    position: fixed;
    z-index: 21;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    transition: opacity 0.3s;
    opacity: 0;
    &.show {
      opacity: 0.5;
    }
  }
  .workflow-container {
    position: absolute;
    background-color: #fff;
    border-radius: 32px 32px 0 0;
    z-index: 22;
    width: 100%;
    box-sizing: border-box;
    padding: 40px 0 40px 40px;
    left: 0;
    bottom: 0;
    transition: transform 0.3s;
    transform: translateY(100%);
    // &.
    &.show {
      transform: translateY(0);
    }
    .close-btn {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 28px;
      height: 28px;
      padding: 40px;
      box-sizing: content-box;
      image {
        display: block;
        width: 28px;
        height: 28px;
      }
    }
    .workflow-title {
      margin-left: -40px;
      line-height: 50px;
      font-size: 36px;
      font-weight: 500;
      padding-bottom: 30px;
      text-align: center;
    }
    .apply-step-container {
      position: relative;
      .dashe-line {
        position: absolute;
        left: 28px;
        top: 0;
        height: 100%;
        border-left: 2px dashed #ddd;
      }
      .apply-step-item {
        position: relative;
        padding-left: 76px;
        padding-right: 40px;
        overflow: hidden;
        &:last-of-type::after {
          content: '';
          position: absolute;
          z-index: 2;
          top: 76px;
          left: 20px;
          background-color: #fff;
          height: 100%;
          width: 26px;
        }
        &.no-wrap {
          padding-right: 32px;
        }
        .item-img {
          position: absolute;
          left: -20px;
          top: 0px;
          width: 56px;
          height: 56px;
          padding: 20px;
          background-color: #fff;
          box-sizing: content-box;
        }
        .item-label {
          line-height: 56px;
          font-size: 32px;
          color: #333;
          padding-top: 20px;
          display: flex;
          align-items: center;
          .label-tag {
            margin-left: 20px;
            line-height: 40px;
            padding: 0 13px;
            color: #16c88b;
            font-size: 24px;
            background: rgba(22, 200, 139, 0.07);
            border-radius: 20px;
          }
        }
        .item-value {
          padding: 10px 0 20px;
          line-height: 42px;
          font-size: 28px;
          color: #666;
          &.no-bottom {
            padding-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
